module.exports = ".customer-form input[type='text'], \r\n.customer-form input[type='number'],\r\n.customer-form input[type='email'],\r\n.customer-form select {\r\n    width:100%;\r\n}\r\n\r\n.customer-form .ng-invalid {\r\n  border-left: 5px solid #a94442;\r\n}\r\n\r\n.customer-form .ng-valid {\r\n  border-left: 5px solid #42A948;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/planmasteraddedit/planmasteraddedit.component.css
// module id = ./src/app/component/planmasteraddedit/planmasteraddedit.component.css
// module chunks = main